// @ts-nocheck
import { AbstractCompositeUserAdInfo } from "./AbstractCompositeUserAdInfo";

export class CompositeUserAdInfo extends AbstractCompositeUserAdInfo {
  constructor() {
    super();
  }

  getVisits(): number {
    // Manual Code Here
  }
}
